module.exports = __webpack_public_path__ + "img/logo.e15ce713.png";